"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skilljar = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _utils = require("./utils");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var FETCH_URL = '/customerEducation/fetch';

/**
 * Generic Skilljar API proxy. Supports both the Admin API and the Learner API.
 *
 * @example Admin API (default)
 * const data = await ChWebSdk.Skilljar.fetch({
 *   apiPath: 'domains/my-domain/published-courses',
 *   query: { limit: 10 }
 * })
 *
 * @example Learner API
 * const data = await ChWebSdk.Skilljar.fetch({
 *   scope: 'learner',
 *   apiPath: 'api/learner/v1/public-courses',
 *   query: { limit: 20, tag__in: ['abc', 'def'] }
 * })
 *
 * @example Learner API (auth is automatic when user is logged in)
 * const data = await ChWebSdk.Skilljar.fetch({
 *   scope: 'learner',
 *   apiPath: 'api/learner/v1/enrolled-courses'
 * })
 */
function fetch(_x) {
  return _fetch.apply(this, arguments);
}
/**
 * Returns the Skilljar domain from app state (populated server-side in window.appState.skilljarDomain).
 *
 * @example
 * const domain = ChWebSdk.Skilljar.getDomain()
 * // e.g. "acme" or null if not configured
 */


function _fetch() {
  _fetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(options) {
    var payload, response, _errBody$status, errBody, skilljarStatus, message;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if ((0, _utils.isBrowser)()) {
              _context.next = 2;
              break;
            }

            throw new Error('Skilljar.fetch can only be called in a browser environment');

          case 2:
            payload = {
              path: options.apiPath
            };
            if (options.scope) payload.api = options.scope;
            if (options.method) payload.method = options.method;
            if (options.query && Object.keys(options.query).length > 0) payload.query = options.query;
            if (options.body !== undefined) payload.body = options.body;
            if (options.headers && Object.keys(options.headers).length > 0) payload.headers = options.headers;
            _context.next = 10;
            return globalThis.fetch((0, _absoluteUrlRuntime.resolveUrl)(FETCH_URL, _absoluteUrlRuntime.UrlSourceType.Api), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': (0, _csrfToken.csrfToken)()
              },
              body: JSON.stringify(payload)
            });

          case 10:
            response = _context.sent;

            if (response.ok) {
              _context.next = 20;
              break;
            }

            _context.next = 14;
            return response.json().catch(function () {
              return {};
            });

          case 14:
            errBody = _context.sent;
            skilljarStatus = (_errBody$status = errBody === null || errBody === void 0 ? void 0 : errBody.status) !== null && _errBody$status !== void 0 ? _errBody$status : response.status;

            if (!(skilljarStatus === 401)) {
              _context.next = 18;
              break;
            }

            throw new Error('Authentication required');

          case 18:
            message = typeof (errBody === null || errBody === void 0 ? void 0 : errBody.error) === 'string' && errBody.error || typeof (errBody === null || errBody === void 0 ? void 0 : errBody.detail) === 'string' && errBody.detail || response.statusText || "HTTP ".concat(skilljarStatus);
            throw new Error("Skilljar fetch failed (".concat(skilljarStatus, "): ").concat(message));

          case 20:
            return _context.abrupt("return", response.json());

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetch.apply(this, arguments);
}

function getDomain() {
  var _appState;

  if (!(0, _utils.isBrowser)()) {
    return null;
  }

  var domain = (_appState = globalThis.appState) === null || _appState === void 0 ? void 0 : _appState.skilljarDomain;
  return typeof domain === 'string' && domain.trim() !== '' ? domain.trim() : null;
}

var Skilljar = {
  fetch: fetch,
  getDomain: getDomain
};
exports.Skilljar = Skilljar;